// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"addc0d8d","787":"f4bd31b8"}[chunkId] + ".chunk.js";
};